import { jsx } from "panel";
import { WizardBreadcrumbsEl } from "common/components/wizard-breadcrumbs";
import { InputEl } from "common/components/input";
import { CheckboxEl } from "common/components/checkbox";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { CreateProjectFieldEl } from "common/widgets/create-project-field";
import { SpinnerEl } from "common/components/spinner";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { SpinnerSize } from "common/components/spinner/types";
import { UserListEl } from "common/widgets/user-list";
import { OrganizationIconEl } from "common/widgets/organization-icon";
import { SelectEl } from "common/components/select";
import { RadioButtonEl } from "common/components/radio-button";
import { IconSizeType } from "common/constants";
import { FullScreenSignupStepId } from "./types";
import { TrackingEvents } from "./tracking";
import breadcrumbsStyleOverride from "./breadcrumbs.inline.styl";
export function template() {
  const {
    step,
    joinedOrgId,
    orgName,
    isDomainVisible,
    joinableOrgs,
    isJoiningOrg,
    isPublicDomain,
    requestedJoinOrgs,
    orgExistsWithIdpEnabled
  } = this.state;
  const MiniNav = () => /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header", "data-sentry-component": "MiniNav", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-row-primary" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-inner" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-left" }, /* @__PURE__ */ jsx("a", { sel: ".mp-chrome-header-left-avatar", attrs: {
    href: "/find-your-org"
  } }, /* @__PURE__ */ jsx(OrganizationIconEl, { attrs: {
    title: "Home"
  }, "data-sentry-element": "OrganizationIconEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-right" }, /* @__PURE__ */ jsx("div", { sel: ".extra-padding" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container" }, /* @__PURE__ */ jsx("div", { attrs: {
    slot: "trigger"
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "settingsMenu",
    "menu-width": 280,
    "menu-height": 570
  }, class: {
    "mp-chrome-header-trigger-container-notif": true
  }, props: {
    sectionsFn: () => this.helpers.getHelpSettingsMenuSections()
  }, on: {
    change: this.helpers.handleHelpSettingsMenuItemSelected
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container-icon", attrs: {
    slot: "trigger"
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-help"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, "Additional Help"))))))))));
  const SkeletonScreen = () => /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-screen", "data-sentry-component": "SkeletonScreen", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-title" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" })), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-container" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    size: SpinnerSize.Large
  }, "data-sentry-element": "SpinnerEl", "data-sentry-source-file": "template.tsx" })));
  const CreateOrgV2 = () => /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-screen", "data-sentry-component": "CreateOrgV2", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-title" }, "Name Your Organization"), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-container" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-step-description" }, "An organization is the home for all your projects, teams, users and billing."), /* @__PURE__ */ jsx(InputEl, { sel: ".full-screen-signup-org-input", attrs: {
    "field-id": "org-name",
    placeholder: "Your organization name (e.g. Mixpanel Org)",
    label: "Organization Name",
    "help-text": "This is usually the name of your company. Your organization name can be changed any time in settings.",
    "style-override": ":host { width: 100%; }"
  }, on: {
    input: this.helpers.handleOrgInput
  }, props: {
    value: this.state.orgName
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), !isPublicDomain && /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-checkbox-area" }, /* @__PURE__ */ jsx(CheckboxEl, { sel: ".full-screen-signup-discover-checkbox", attrs: {
    checked: this.state.isDomainVisible
  }, on: {
    click: this.helpers.handleIsDomainVisibleClick
  } }, "Anyone with your domain can join"), /* @__PURE__ */ jsx(SvgIconEl, { sel: ".info-icon", attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Right,
    "max-width": "250px"
  } }, "Checking this will allow anyone with your domain to join your organization automatically. You may change permissions later in settings.")), /* @__PURE__ */ jsx("div", { sel: ".data-residency-radio-group" }, /* @__PURE__ */ jsx("div", { sel: ".label .mp-input-label" }, "Select Where To Store Your Data", /* @__PURE__ */ jsx("div", { sel: ".info" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom,
    "max-width": "300px"
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, "If you are a Mixpanel customer in the EU, you have the option to send your data to Mixpanel's EU data center. You do not lose any product capability if you choose to store your data in the EU."))), /* @__PURE__ */ jsx("div", { sel: ".radio-btn", on: {
    click: () => this.update({
      selectedDataResidency: "US"
    })
  } }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: this.state.selectedDataResidency === "US", children: "\u{1F1FA}\u{1F1F8} United States", "data-sentry-element": "RadioButtonEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".radio-btn", on: {
    click: () => this.update({
      selectedDataResidency: "EU"
    })
  } }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: this.state.selectedDataResidency === "EU", children: "\u{1F1EA}\u{1F1FA} European Union", "data-sentry-element": "RadioButtonEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Primary,
    disabled: this.state.orgName.trim().length === 0 || this.state.executingCreateOrg
  }, on: {
    click: this.helpers.createOrgV2Callback
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Next")));
  const JoinExistingOrg = () => /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-screen", "data-sentry-component": "JoinExistingOrg", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-title" }, "Join an Existing Organization"), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-container .full-screen-signup-join-org" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-list", class: {
    "full-screen-signup-center": (joinableOrgs === null || joinableOrgs === void 0 ? void 0 : joinableOrgs.length) < 4
  } }, joinableOrgs.map((org) => {
    const {
      id,
      name,
      owner_email,
      num_projects,
      discoverable,
      list_members
    } = org;
    return /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-org-item" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-name-area" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-org-name" }, name, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      placement: Placement.Top,
      "max-width": "250px"
    } }, name)), joinedOrgId === id && isJoiningOrg ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(ButtonEl, { sel: ".full-screen-signup-org-joinable", attrs: {
      disabled: isJoiningOrg
    }, on: {
      click: () => this.helpers.joinOrg(org)
    } }, discoverable === this.DISCOVERABLE_REQUEST ? requestedJoinOrgs.includes(id) ? "Requested" : "Request to Join" : "Join")), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-org-info-area" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-org-owner" }, /* @__PURE__ */ jsx("span", { sel: ".medium-bold" }, owner_email), " (owner)"), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-org-projects" }, /* @__PURE__ */ jsx("span", { sel: ".medium-bold" }, num_projects), " ", num_projects > 1 ? "projects" : "project")), /* @__PURE__ */ jsx(UserListEl, { sel: ".full-screen-signup-user-list", attrs: {
      "max-icons-displayed": 4,
      size: IconSizeType.Large,
      users: this.helpers.getUserList(list_members)
    } }));
  }), /* @__PURE__ */ jsx(ButtonEl, { on: {
    click: () => {
      mixpanel.track(TrackingEvents.ClickCreateNewOrg);
      this.helpers.goToNextStep();
    }
  }, sel: ".full-screen-signup-org-item-btn", attrs: {
    icon: "plus",
    theme: ButtonTheme.Tertiary,
    "style-override": ":host { color: var(--blue1); }",
    disabled: isJoiningOrg
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Create New Organization")), orgExistsWithIdpEnabled && /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-sso-admin-message" }, "Looking for an organization that's not on this list?", " ", /* @__PURE__ */ jsx("strong", null, "Find your Mixpanel admin and request access."))));
  const CreateProject = () => /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-screen", "data-sentry-component": "CreateProject", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-title" }, "Your First Project"), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-container" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-step-description" }, "Projects live within an organization and can be thought of as containers for your Mixpanel data."), /* @__PURE__ */ jsx(CreateProjectFieldEl, { attrs: {
    "is-fyt": true,
    "button-area-align": "left",
    "fyt-org-settings": {
      name: orgName,
      discoverability: isDomainVisible ? this.DISCOVERABLE_OPEN : this.DISCOVERABLE_CLOSED
    }
  }, on: {
    create: this.helpers.handleProjectCreate
  }, "data-sentry-element": "CreateProjectFieldEl", "data-sentry-source-file": "template.tsx" })));
  const Congratulations = () => /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-screen", "data-sentry-component": "Congratulations", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-congrats-hands" }), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-title" }, "Congratulations!"), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-orgs-container .full-screen-signup-congrats" }, /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-step-description" }, "You've successfully created your organization ", /* @__PURE__ */ jsx("span", { sel: ".bold" }, this.state.orgName), " and your first project", " ", /* @__PURE__ */ jsx("span", { sel: ".bold" }, this.state.projectName)), /* @__PURE__ */ jsx(ButtonEl, { sel: ".full-screen-signup-get-started", attrs: {
    size: ButtonSize.Large,
    theme: ButtonTheme.Primary
  }, on: {
    click: () => location.href = this.helpers.getRedirectLink()
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Let's Get Started")));
  const renderStep = () => {
    switch (step) {
      case FullScreenSignupStepId.JOIN_EXISTING_ORG:
        return /* @__PURE__ */ jsx(JoinExistingOrg, null);
      case FullScreenSignupStepId.CREATE_ORG:
        return /* @__PURE__ */ jsx(CreateOrgV2, null);
      case FullScreenSignupStepId.CREATE_PROJECT:
        return /* @__PURE__ */ jsx(CreateProject, null);
      case FullScreenSignupStepId.CONGRATULATIONS:
        return /* @__PURE__ */ jsx(Congratulations, null);
      default: {
        const unreachable = step;
        throw new Error("unknown sign up step ".concat(unreachable));
      }
    }
  };
  if (step === FullScreenSignupStepId.CREATE_ORG) {
    mixpanel.track(TrackingEvents.CreateOrgScreen);
  }
  if (step === FullScreenSignupStepId.CREATE_PROJECT) {
    mixpanel.track(TrackingEvents.CreateProjectScreen);
  }
  return /* @__PURE__ */ jsx("div", { "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(MiniNav, { "data-sentry-element": "MiniNav", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".full-screen-signup-container" }, joinableOrgs === null ? /* @__PURE__ */ jsx(SkeletonScreen, null) : /* @__PURE__ */ jsx(null, null, step !== FullScreenSignupStepId.JOIN_EXISTING_ORG && step !== FullScreenSignupStepId.CONGRATULATIONS && /* @__PURE__ */ jsx(WizardBreadcrumbsEl, { attrs: {
    breadcrumbs: this.helpers.getBreadcrumbs(),
    "style-override": breadcrumbsStyleOverride
  }, on: {
    nodeClicked: this.helpers.handleBreadcrumbClick
  } }), renderStep())));
}
